import $ from 'jquery';

const initAccountSelection = () => {
    const $type = $('.c-account-type');

    if ($type.length <= 0) {
        return;
    }

    $type.click(function() {
        const $el = $(this);

        $type.removeClass('selected');
        $el.addClass('selected');

        const target = $el.data('target');
        $('.c-account-type-content').addClass('hidden');
        $(`#${target}`).removeClass('hidden');
    });
};

$(() => {
    initAccountSelection();
});

window.initAccountSelection = initAccountSelection;

// JS logic added on BED side due to Kentico multi form nature not being able to read JS on subsequent pages
// Left here for reference

// GOOGLE RECAPTCHA
// grecaptcha.ready(function () {
//     grecaptcha
//         .execute(
//             '<%# SchneiderElectric.Library.Helpers.GoogleRecaptchaHelper.GoogleRecaptcaSiteKey %>',
//             { action: 'submit' }
//         )
//         .then(function (token) {
//             hdnRecaptchaToken.value = token;
//         });
// });

// REGISTRATION SUBMISSION
// const regoButton = document.getElementById('rego-form-submit');
// regoButton.addEventListener('click', function (e) {
//     const bizName = document.getElementById(
//         '<%= txtBusinessName.ClientID %>'
//     ).value;
//     const taxId = document.getElementById('<%= txtTaxID.ClientID %>').value;
//     const empNumber = document.getElementById(
//         '<%= ddlEmployeeNumber.ClientID %>'
//     ).value;
//     const areaOfocus = document.getElementById(
//         '<%= ddlAreaOfFocus.ClientID %>'
//     ).value;
//     const role = document.getElementById('<%= ddlRole.ClientID %>').value;

//     const allRequiredDataValid =
//         bizName.trim() != '' &&
//         taxId.trim() != '' &&
//         empNumber.trim() != '' &&
//         areaOfocus.trim() != '' &&
//         role.trim() != '';

//     if (allRequiredDataValid) {
//         e.preventDefault();
//         const loading = document.getElementsByClassName('loading')[0];
//         loading.classList.add('show');
//     }

//     const btnRegistrationSubmit = document.getElementById(
//         'btnRegistrationSubmit'
//     );
//     btnRegistrationSubmit.click();
// });

// FIRST PAGE HANDLING ADDITIONAL HTML AND FORM FIELD REMOVAL IF EXISTING EMAIL IS FOUND
// const emailClearBtn = document.querySelector('.clear-email-btn');
// const emailValidation = document.querySelector('.email-validation');
// const emailField = document.querySelector('#txtEmailAddress');
// const nextPageBtn = document.querySelector('#lbContinueToContact');
// const emailFound = document.querySelector('#pnlEmailExist');

// if (emailFound) {
//     emailClearBtn.style.display = 'block';
//     emailValidation.style.display = 'block';
//     nextPageBtn.classList.add('btn-disabled');
// }

// emailClearBtn.addEventListener('click', () => {
//     emailClearBtn.style.display = 'none';
//     emailValidation.style.display = 'none';
//     nextPageBtn.classList.remove('btn-disabled');
//     emailField.value = '';
// });

// emailField.addEventListener('keyup', () => {
//     if (emailField.value === '' && emailValidation.classList.contains('show')) {
//         emailClearBtn.style.display = 'none';
//         emailValidation.style.display = 'none';
//         nextPageBtn.classList.remove('btn-disabled');
//         emailField.value = '';
//     }
// });
